export class Project {
    constructor(
        public IDProject: number,
        public IDContract: number,
        public Name: string,
        public ExternalProjectID: string,
    ) { };
}



// WEBPACK FOOTER //
// ./src/models/project.ts